import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-028f3c39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = ["maxlength", "placeholder"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 20 20",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.5 4.5L13 10L7.5 15.5",
    stroke: "currentColor",
    "stroke-width": "1.67",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  maxLength: {
    type: Number,
    default: 100
  }
},
  emits: ['update:modelValue', 'completed'],
  setup(__props, { emit: __emit }) {

const props = __props

let model = ref(props.modelValue);

const emit = __emit;

const updateValue = (event: any) => {
  emit('update:modelValue', event.target.value);
};

const completed = () => {
  if (model.value.length > 0) {
    emit('completed');
  }
  model.value = '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      id: "selectNameInput",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
      onInput: updateValue,
      class: "input",
      maxlength: props.maxLength,
      minlength: "1",
      placeholder: __props.placeholder,
      onKeypress: _withKeys(completed, ["enter"])
    }, null, 40, _hoisted_2), [
      [_vModelText, _unref(model)]
    ]),
    _createElementVNode("button", {
      class: "submit-btn",
      type: "submit",
      "aria-label": "Submit",
      onClick: completed
    }, _hoisted_4)
  ]))
}
}

})